import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    join: 'Enter for',
    colBattle: 'Battle',
    colCases: 'Cases',
    colPlayers: 'Players',
    watch: 'Watch',
    results: 'Outcome',
    cancelled: 'Cancelled',
    round: 'Round',
    bank: 'Dropped',
  },
  ru: {
    join: 'Вступить за',
    colBattle: 'Баттл',
    colCases: 'Кейсы',
    colPlayers: 'Игроки',
    watch: 'Смотреть',
    results: 'Итоги',
    cancelled: 'Отменён',
    round: 'Раунд',
    bank: 'Выбито',
  },
  uz: {
    join: 'Qoʻshilish',
    colBattle: 'Jang',
    colCases: 'Keyslar',
    colPlayers: 'Oʻyinchilar',
    watch: 'Koʻrish',
    results: 'Yakun',
    cancelled: 'Bekor qilindi',
    round: 'Raund',
    bank: 'Tushdi',
  },
  fa: {
    join: 'ورود با',
    colBattle: 'نبرد',
    colCases: 'کیس‌ها',
    colPlayers: 'بازیکنان',
    watch: 'تماشا',
    results: 'نتیجه',
    cancelled: 'لغو شد',
    round: 'راند',
    bank: 'افتاده',
  },
  pt: {
    join: 'Entrar por',
    colBattle: 'Batalha',
    colCases: 'Caixas',
    colPlayers: 'Jogadores',
    watch: 'Assistir',
    results: 'Resultado',
    cancelled: 'Cancelada',
    round: 'Rodada',
    bank: 'Caiu',
  },
  tr: {
    join: 'Katıl:',
    colBattle: 'Savaş',
    colCases: 'Kasalar',
    colPlayers: 'Oyuncular',
    watch: 'İzle',
    results: 'Sonuç',
    cancelled: 'İptal',
    round: 'Raund',
    bank: 'Düşen',
  },
});
